import type { GetVenuesQuery, GetVenuesResponse } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

const GET_VENUES_LIMIT = 50

function getVenues(query: GetVenuesQuery): Promise<GetVenuesResponse> {
  return requestApiJsonOrThrow<GetVenuesResponse>('admin/venues', {
    params: query,
  })
}

export const venuesQuery = (queryParams: GetVenuesQuery) => ({
  queryKey: ['venues', queryParams],
  queryFn: async ({ pageParam = 0 }: { pageParam?: number }) =>
    getVenues({
      limit: GET_VENUES_LIMIT.toString(),
      offset: pageParam.toString(),
      ...queryParams,
    }),
  getNextPageParam: (lastPage: GetVenuesResponse, pages: GetVenuesResponse[]) => {
    if (lastPage.data.length < GET_VENUES_LIMIT) return
    return pages.length * GET_VENUES_LIMIT
  },
})
